import makeStyles from '@mui/styles/makeStyles';

const textDefaultColor = "#465869";
const textDarkerColor = "#475467";

const setFontStyle = (lineHeight: string) => ({
  font: `600 16px/${lineHeight} Manrope`,
  color: textDefaultColor,
});

const styles = makeStyles(() => ({
  mainDiv: {
    position: "relative",
    paddingBottom: "40px",
  },
  title: {
    ...setFontStyle("22px"),
  },
  wrapperHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  mr5: {
    marginRight: 5,
  },
  wrapperButton: {
    display: "flex",
    alignItems: "center",
  },
  wrapperAccordion: {
    border: "1px solid #e4e7ec",
    borderRadius: "12px !important",
    boxShadow: "none !important",
    "&:not(:last-child)": {
      marginBottom: 5,
    },
    "&::before": {
      height: "0px !important",
    },
  },
  wrapperAccordionSummary: {
    "& .MuiAccordionSummary-content": {
      display: "flex",
      alignItems: "center",
    },
  },
  accordionTitle: {
    ...setFontStyle("24px"),
    width: "45%",
    flexShrink: 0,
  },
  documentsField: {
    marginTop: "16px",
    marginBottom: "20px",
  },
  actionButtons: {
    position: "absolute",
    bottom: "-12px",
    right: "7px",
  },
  wrapper: {
    paddingBottom: 12,
  },
  wrapperEmptyComponent: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    marginBottom: 32,
    "& span": {
      font: "500 24px/32px Manrope",
      color: textDarkerColor,
    },
  },
  emptyDocumentImage: {
    marginBottom: 32,
    width: 350,
  },
  withInactiveButton: {
    width: "100%",
    paddingLeft: 12,
  },
  withoutInactiveButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
}));

export default styles;
